import type { Editor } from 'slate';
import type { EditorTabState, UpdateContext } from 'src/layout-engine/utils/weak-maps/weak-maps';
import type { EditorFocus } from 'src/types/general';

const maps = {
  EDITOR_FOCUS: new WeakMap<Editor, EditorFocus>(),
  EDITOR_TO_INPUT_HANDLER: new Map<Editor, HTMLElement>(),
  EDITOR_TO_TAB_STATE: new Map<Editor, EditorTabState>(),
  EDITOR_TO_UPDATE_CONTEXT: new Map<Editor, UpdateContext>(),
  IS_READ_ONLY: new Map<Editor, boolean>(),
};

export default maps;
